export default class Header {
    constructor() {
        this.nav = document.querySelector('.l-gnav');
        this._init();
    }

    _init() {
        this._getEl();
    }

    _getEl() {
        const $toggle = document.querySelector('.js-header__toggle');

        $toggle && this._registerEvent($toggle);
    }

    _registerEvent($toggle) {
        $toggle.addEventListener('click', () => {
            document.body.classList.toggle('-active_gnav');
            if (document.body.classList.contains('-active_gnav')) {
                this.nav.classList.remove('-close');
                this.nav.classList.add('-open');
            } else {
                this.nav.classList.remove('-open');
                this.nav.classList.add('-close');
            }
        });
    }
}
